// extracted by mini-css-extract-plugin
export default {"header":"Header_header__2t6Je","container":"Header_container__ow5lQ","logo":"Header_logo__G+ea6","slogan":"Header_slogan__LXk9L","cta":"Header_cta__YCMmS"};